import styled from "styled-components";

const Wrapper = styled.section`
  .dashboard {
    display: grid;
    grid-template-columns: 1fr;
  }
  .dashboard-page {
    width: 95vw;
    margin: 0 auto;
    padding: 1rem 0;
    padding-top: 4.25rem;
  }
  @media (min-width: 992px) {
    .dashboard {
      grid-template-columns: auto 1fr;
    }
    .dashboard-page {
      width: 98%;
      margin: 0 1rem;
    }
  }
`;
export default Wrapper;
